import React, { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'

const BASE = '/admin/experiences'

/**
 * v7 "New experience ▾" dropdown (`.new-exp-wrap` / `.menu`).
 * Shared by Home and the Experience list header.
 *
 * Copy from: prefer `onCopyFrom` (opens picker on the current page).
 * Fallback: navigate to Experiences with openCopyFlow for pages without the modal.
 */
const CreateExperienceMenu = ({ label = 'New experience ▾', onCopyFrom }) => {
  const history = useHistory()
  const [open, setOpen] = useState(false)
  const wrapRef = useRef(null)

  useEffect(() => {
    if (!open) {
      return undefined
    }
    const onDocClick = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false)
      }
    }
    const onKeyDown = (e) => {
      if (e.key === 'Escape') {
        setOpen(false)
      }
    }
    document.addEventListener('mousedown', onDocClick)
    document.addEventListener('keydown', onKeyDown)
    return () => {
      document.removeEventListener('mousedown', onDocClick)
      document.removeEventListener('keydown', onKeyDown)
    }
  }, [open])

  const handleCopyFrom = () => {
    setOpen(false)
    if (typeof onCopyFrom === 'function') {
      onCopyFrom()
      return
    }
    history.push({
      pathname: `${BASE}/active`,
      state: { openCopyFlow: true },
    })
  }

  return (
    <div className='experience-create-wrap' ref={wrapRef}>
      <button
        type='button'
        className='btn-navy'
        aria-haspopup='true'
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}>
        {label}
      </button>
      {open ? (
        <div className='experience-create-menu' role='menu'>
          <h4>Create</h4>
          <button
            type='button'
            role='menuitem'
            className='experience-create-item'
            onClick={() => {
              setOpen(false)
              history.push(`${BASE}/create-new`)
            }}>
            <span>
              Start from scratch
              <small>
                A blank experience. Add the name, dates and content yourself.
              </small>
            </span>
          </button>
          <button
            type='button'
            role='menuitem'
            className='experience-create-item'
            onClick={handleCopyFrom}>
            <span>
              Copy from another experience
              <small>
                Reuse content, enrollment and prep, then change what should be
                unique.
              </small>
            </span>
          </button>
        </div>
      ) : null}
    </div>
  )
}

CreateExperienceMenu.propTypes = {
  label: PropTypes.string,
  onCopyFrom: PropTypes.func,
}

export default CreateExperienceMenu
